import React, { useState, useEffect } from "react";
import { Search, Bell, User, LogOut, ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { logout } from "../services/authUtils";
import "./Navbar.css";

const Navbar = ({ onCreate }) => {
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState({
    displayName: "User",
    username: ""
  });

  useEffect(() => {
    // Get user info from localStorage
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);

        // Construct display name (First + Last or Fallback)
        let name = "User";
        if (user.firstName && user.lastName) {
          name = `${user.firstName} ${user.lastName}`;
        } else {
          name = user.firstName || user.name || user.username || user.userName || user.email || "User";
        }

        // Construct @username
        const handle = user.username || user.userName || "";

        setUserProfile({
          displayName: name,
          username: handle ? `@${handle.replace(/^@/, '')}` : ""
        });
      } catch (e) {
        console.error("Error parsing user data:", e);
      }
    }
  }, []);

  const handleLogout = () => {
    logout("");
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="logo-container" onClick={() => navigate("/")}>
          <svg
            className="product-icon"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: "pointer" }}
          >
            <path
              d="M 20 35 L 45 35"
              stroke="#1E40AF"
              strokeWidth="4"
              strokeLinecap="round"
            ></path>
            <path
              d="M 20 50 L 55 50"
              stroke="#14B8A6"
              strokeWidth="4"
              strokeLinecap="round"
            ></path>
            <path
              d="M 20 65 L 65 65"
              stroke="#F59E0B"
              strokeWidth="4"
              strokeLinecap="round"
            ></path>
            <path d="M 45 35 L 55 40 L 45 45 Z" fill="#1E40AF"></path>
            <path d="M 55 50 L 65 55 L 55 60 Z" fill="#14B8A6"></path>
            <path d="M 65 65 L 75 70 L 65 75 Z" fill="#F59E0B"></path>
            <circle cx="80" cy="50" r="8" fill="#1E40AF"></circle>
          </svg>
          <span className="logo-text">SequFlow</span>
        </div>
      </div>

      <div className="navbar-right">
        <div className="navbar-actions">
          <div className="search-wrapper">
            <Search size={18} className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              className="nav-search-input"
            />
          </div>
          {onCreate && (
            <button className="nav-create-btn" onClick={onCreate}>
              + Create
            </button>
          )}
          <button className="icon-btn">
            <Bell size={20} />
            <span className="notification-dot"></span>
          </button>

          <div className="user-profile-container">
            <div className="user-profile-small">
              <User size={20} />
            </div>
            <span className="navbar-user-name-label">{userProfile.displayName}</span>
            <ChevronDown size={14} className="dropdown-arrow-icon" />

            <div className="profile-dropdown">
              <div className="dropdown-header">
                <span className="user-name">{userProfile.displayName}</span>
                {userProfile.username && (
                  <span className="user-handle">{userProfile.username}</span>
                )}
              </div>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item logout-btn" onClick={handleLogout}>
                <LogOut size={16} />
                <span>Log out</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
